import React from 'react';

import { useIntl } from '../../../util/reactIntl';
import { createSlug } from '../../../util/urlHelpers';
import { formatMoney } from '../../../util/currency';
import { types as sdkTypes } from '../../../util/sdkLoader';

import { FieldRadioButtonGroup } from '../../../components';

import css from './PriceVariantPicker.module.css';

const { Money } = sdkTypes;

const PriceVariantPicker = props => {
  const intl = useIntl();
  const { priceVariants, onPriceVariantChange, disabled, currency } = props;
  const hasPriceVariants = priceVariants?.length > 0;

  // If currency is not available, don't render the component
  if (!currency) {
    return null;
  }

  return hasPriceVariants ? (
    <FieldRadioButtonGroup
      name="priceVariantName"
      id="priceVariant"
      className={css.priceVariantFieldSelect}
      selectClassName={css.priceVariantSelect}
      label={intl.formatMessage({ id: 'PriceVariantPicker.priceVariantLabel' })}
      onChange={onPriceVariantChange}
      disabled={disabled}
      showLabelAsDisabled={disabled}
      layout="buttonGroup"
      orientation="horizontal"
      options={priceVariants.map(pv => {
        const price = new Money(pv.priceInSubunits, currency);
        const formattedPrice = formatMoney(intl, price);
        return {
          key: pv.name,
          label: (
            <span className={css.variantLabel}>
              <span className={css.variantName}>{pv.name}</span>
              <span className={css.variantPrice}>{formattedPrice}</span>
            </span>
          ),
          slug: createSlug(pv.name),
        };
      })}
    />
  ) : null;
};

export default PriceVariantPicker;
